import React, { useEffect } from 'react';
import { useModalProps } from '@kallidus/common';
import { VERSION_MISMATCH_KEY } from '@ApplicationWide/version-checking';
import VersionCheckModal from './VersionCheckModal';

//Adapted from https://www.codemzy.com/blog/clients-reload-single-page-application-update
const VersionCheck = () => {
  const { openModal, modalProps } = useModalProps();

  useEffect(() => {
    window.addEventListener(VERSION_MISMATCH_KEY, openModal);
    return () => window.removeEventListener(VERSION_MISMATCH_KEY, openModal);
  }, [openModal]);

  return <VersionCheckModal {...modalProps} />;
};

export default VersionCheck;
